/**
 *  首页
 */

const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/app/admin/dashboard/index");

const Message = () =>
  import(/* webpackChunkName: "dashboard" */ "@/app/account/message/index");

export default [
  { path: "", redirect: "dashboard" },
  {
    path: "message",
    name: "message",
    component: Message,
    meta: { title: "消息", key: "", permission: "" }
  },
  {
    path: "dashboard",
    name: "index",
    component: Dashboard,
    meta: { title: "首页", key: "dashboard", permission: "" }
  }
];
